import GeneralButton from "../common/GeneralButton";
import ExpandedModal from "../common/mediaGallery/ExpandedModal";
import { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination, Autoplay } from "swiper/modules";
import { cleanHTML, cleanHTML2 } from "../utils/commonHelper";

const DetailsComponent = ({ recipe }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  // --- NEW: swiper reference & active index ---
  const [swiperRef, setSwiperRef] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);
  const handleConfirm = () => setIsModalOpen(false);

  if (!recipe) return null;

  // -------------------- Calculate media --------------------
  const media = [];
  if (recipe.image) media.push({ image: recipe.image, title: recipe.title });
  if (recipe.pictures?.length > 0) {
    media.push(
      ...recipe.pictures.map((pic) => ({ image: pic.image, title: pic.title }))
    );
  }

  const totalSlides = media.length;
  const picturesCount = media.length;
  const videosCount = recipe.videos?.length || 0;

  return (
    <div className="grid lg:grid-cols-[1fr_250px] xl:grid-cols-[1fr_450px] gap-4 md:gap-6 lg:gap-10 items-start">
      {/* Left Content */}
      <div className="bg-[#f0f2f0] rounded-[15px] p-6 md:px-10 lg:px-12 lg:py-10 2xl:p-12 flex flex-col gap-4">
        {recipe.title && <h1 className="text-32pt md:text-36pt">{recipe.title}</h1>}

        {recipe.description && (
          <div className="text-gray-700 leading-relaxed">
            <div
              className="text-24pt font-mono terms-container"
              dangerouslySetInnerHTML={{ __html: cleanHTML2(recipe.description) }}
            />
          </div>
        )}

        {recipe.youtubeLink && (
          <div className="mt-4">
            <GeneralButton
              text="Watch on YouTube"
              title="Click to watch on YouTube"
              className="text-24pt py-1.5 px-4"
              bgColor="#ff0000"
              onClick={() => window.open(recipe.youtubeLink, "_blank")}
            />
          </div>
        )}
      </div>

      {/* Right: Image Swiper */}
      {media.length > 0 && (
        <div
          className="w-full lg:max-w-[450px] cursor-pointer"
          title={
            picturesCount + videosCount > 1
              ? `Click to view all media`
              : `Click to enlarge`
          }
        >
          {/* Swiper Wrapper */}
          <div className="relative mx-auto xxs:max-w-[250px] xs:max-w-[300px] md:max-w-[350px] lg:max-w-[450px] aspect-square rounded-2xl overflow-hidden">
            <Swiper
              onSwiper={setSwiperRef}
              onSlideChange={(s) => setActiveIndex(s.realIndex)}
              autoplay={{
                delay: 7500,
                pauseOnMouseEnter: true,
                disableOnInteraction: false,
              }}
              loop
              modules={[Pagination, Autoplay]}
              className="w-full h-full"
            >
              {media.map((item, index) => (
                <SwiperSlide
                  key={index}
                  className="flex items-center justify-center"
                  onClick={handleOpenModal}
                >
                  <img
                    src={
                      process.env.REACT_APP_BACKEND_URL + "public/" + item.image
                    }
                    alt={item.title}
                    className="w-full h-full object-cover rounded-[15px] bg-gray"
                    onError={(e) => {
                      e.target.src = require("../../assets/images/link.png");
                      e.target.classList.add("object-contain");
                    }}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>

          {/* --- CUSTOM BULLETS BELOW SWIPER --- */}
          {media.length > 1 && (
            <div className="flex justify-center flex-wrap gap-2 mt-6">
              {Array.from({ length: totalSlides }).map((_, i) => (
                <button
                  key={i}
                  onClick={() => swiperRef.slideTo(i)}
                  style={{
                    width: "32px",
                    height: "14px",
                  }}
                  className={`rounded-[7px] transition-all
        ${i === activeIndex ? "bg-black" : "bg-none border border-2"}
      `}
                ></button>
              ))}
            </div>
          )}
        </div>
      )}

      {/* Modal */}
      {isModalOpen && (
        <ExpandedModal
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          onConfirm={handleConfirm}
          data={{
            title: recipe.title,
            pictures: media,
            videos: recipe.videos || [],
            // <-- 🔥 passed active index to modal
          }}
          initialIndex={activeIndex}
        />
      )}
    </div>
  );
};

export default DetailsComponent;
